import { ChangeMap } from '../renderer-manager';

export abstract class Processor {
    private afterCleanupTasks: Array<() => void> = [];

    beforeRender() {}
    beforeDeletions(deletions: ChangeMap) {}
    afterDeletions(deletions: ChangeMap) {}
    beforeUpdates(changes: ChangeMap) {}
    afterUpdates(changes: ChangeMap) {}
    afterCleanup(func: () => void) {
        this.afterCleanupTasks.push(func);
    }
    doAfterCleanup() {
        this.afterCleanupTasks.forEach(task => task());
        this.afterCleanupTasks.clear();
    }
    dispose() {}
}
